import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from "recompose";
import moment from "moment";

import { withStyles } from '@material-ui/core/styles';

import EnhancedTable from './EnhancedTable';
import EnhancedTableTW from './EnhancedTableTW';
import ReadOnlyFormComponent from './ReadOnlyFormComponent';
import ReadOnlyFormComponentTW from './ReadOnlyFormComponentTW';
import TimesheetFormComponent from './FormComponent';
import TimesheetFormComponentTW from './FormComponentTW';
import Progress from '../Common/Progress';
import ImportCSV from './ImportCSV';

import { userActions, projectActions, tasksissuesActions, timesheetActions } from '../../_actions';

const formatter1 = 'YYYY-MM-DD';

const styles = theme => ({
    Content: {
        display: 'flex',
        flexWrap: 'wrap',
    },
});

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            timesheetId: '',
            taskId: '',
            readOnlyTimesheetTableOpen: false,
            selectedDate: '',
            importCsvData: [],
            importCsvOpen: false,
            openProgress: false
        };
    }

    componentDidMount() {
        this.props.dispatch(userActions.getAll());
        this.props.dispatch(projectActions.getAllByUserId(this.props.user.id));
        this.props.Pagename === 'Project' ? this.props.dispatch(tasksissuesActions(this.props.ProjectId)) :
            this.props.dispatch(tasksissuesActions.getAllByUserId(this.props.user.id));
        this.props.dispatch(timesheetActions.getAllByDepartmentId(this.props.user.departmentId, this.props.user.id));
    }

    handleOpen = (date) => {
        this.cleanData();

        this.setState({
            open: true,
            modalTitle: 'Create Timesheet',
            taskId: '',
            timesheetId: '',
            selectedDate: date
        });
    };

    handleEditTable = (EditData) => {
        this.setState({
            open: true,
            timesheetId: EditData.id,
        });
    }

    handleDeleteTable = (DeleteData) => {
        this.props.dispatch(timesheetActions.delete(DeleteData));
    }

    handleDuplicateTable = (DuplicateData) => {
        const DataProcessing = async () => {
            try {
                await this.props.dispatch(timesheetActions.duplicate(DuplicateData));
                await this.props.dispatch(timesheetActions.getAllByDepartmentId(this.props.user.departmentId, this.props.user.id));
            } catch (e) {
                console.error("Problem", e)
            }
        }

        DataProcessing();
    }

    cleanData() {
        this.setState({
            open: false,
            taskId: '',
            timesheetId: '',
            importCsvData: [],
            importCsvOpen: false,
            openProgress: false
        });
    }

    handleClose = () => {
        this.cleanData();
    }

    handleReadOnlyTable = (DetailData) => {
        this.setState({
            timesheetId: DetailData.id,
            readOnlyTimesheetTableOpen: true
        })
    }

    handleReadOnlyTimesheetClose = () => {
        this.setState({
            readOnlyTimesheetTableOpen: false
        })
    }

    handleCsvUpload = (dataArray) => {
        if (dataArray) {

            let jsonArray = [];
            for (let i = 1; i < dataArray.length; i++) {
                if (moment(dataArray[i][1]).format(formatter1) !== 'Invalid date' && dataArray[i][2] && dataArray[i][2].length !== 0) {
                    let json = {
                        "id": i,
                        "UserId": this.props.user.id,
                        "Date": moment(dataArray[i][1]).format(formatter1),
                        "CostUnitId": dataArray[i][2],
                        "SubCategoryId": dataArray[i][3] && dataArray[i][3].length !== 0 ? dataArray[i][3] : "",
                        "SubCategoryName": dataArray[i][3],
                        "Notes": dataArray[i][6],
                        "Hours": dataArray[i][7] !== '' ? dataArray[i][7] : 0,
                        "HoursOvertime": dataArray[i][8] !== '' ? dataArray[i][8] : 0,
                        "ProjectId": Number.parseInt(dataArray[i][4], 10) ? Number.parseInt(dataArray[i][4], 10) : 0,
                        "TaskName": dataArray[i][5], //Number.parseInt(dataArray[i][5], 10) ? Number.parseInt(dataArray[i][5], 10) : 0,
                        "Satisfaction": 3,
                        "DepartmentId": this.props.user.departmentId,
                        "CreatedUserId": this.props.user.id,
                        "UpdatedUserId": this.props.user.id
                    }

                    jsonArray.push(json);
                }
            }

            this.setState({
                importCsvOpen: true,
                importCsvData: jsonArray
            });
        }
    }

    handleCsvSaveClick = () => {
        const insertData = async () => {
            try {
                this.setState({
                    openProgress: true
                })

                await this.props.dispatch(timesheetActions.insert(this.state.importCsvData));
                await this.props.dispatch(timesheetActions.getAllByDepartmentId(this.props.user.departmentId, this.props.user.id));
                this.handleClose();
            } catch (e) {
                console.error("Problem", e)
            }
        }

        insertData();
    }


    render() {
        const { user } = this.props;

        return (
            <div>
                <Progress openProgress={this.state.openProgress} />
                <ImportCSV
                    open={this.state.importCsvOpen}
                    data={this.state.importCsvData}
                    handleCsvSaveClick={this.handleCsvSaveClick}
                    close={this.handleClose} />

                {
                    user.departmentLocate === 'TW' ?
                        <EnhancedTableTW
                            handleReadOnlyTable={this.handleReadOnlyTable}
                            handleEditTable={this.handleEditTable}
                            handleDeleteTable={this.handleDeleteTable}
                            handleDuplicateTable={this.handleDuplicateTable}
                            handleOpen={this.handleOpen}
                            OwnerUserId={user.id}
                            handleCsvUpload={this.handleCsvUpload}
                            Pagename='Timesheet'
                        /> :
                        <EnhancedTable
                            handleReadOnlyTable={this.handleReadOnlyTable}
                            handleEditTable={this.handleEditTable}
                            handleDeleteTable={this.handleDeleteTable}
                            handleDuplicateTable={this.handleDuplicateTable}
                            handleOpen={this.handleOpen}
                            OwnerUserId={user.id}
                            Pagename='Timesheet'
                        />
                }

                {
                    user.departmentLocate === 'TW' ?
                        <TimesheetFormComponentTW
                            open={this.state.open}
                            close={this.handleClose}
                            TaskId={this.state.taskId}
                            TimesheetId={this.state.timesheetId}
                            selectedDate={this.state.selectedDate}
                        /> :
                        <TimesheetFormComponent
                            open={this.state.open}
                            close={this.handleClose}
                            TaskId={this.state.taskId}
                            TimesheetId={this.state.timesheetId}
                            selectedDate={this.state.selectedDate}
                        />

                }

                {
                    user.departmentLocate === 'TW' ?
                        <ReadOnlyFormComponentTW
                            open={this.state.readOnlyTimesheetTableOpen}
                            close={this.handleReadOnlyTimesheetClose}
                            TimesheetId={this.state.timesheetId}
                        />
                        :
                        <ReadOnlyFormComponent
                            open={this.state.readOnlyTimesheetTableOpen}
                            close={this.handleReadOnlyTimesheetClose}
                            TimesheetId={this.state.timesheetId}
                        />
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { users, projects, tasksissues, timesheet } = state;

    return {
        user,
        users,
        projects,
        tasksissues,
        timesheet
    };
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles, { withTheme: true }))(App);


// WEBPACK FOOTER //
// ./src/components/Timesheet/App.js